<template>
  <div class="select select--input">
    <div class="dropdown dropdown--full-width">
      <Popper
        v-model:open="open"
        placement="bottom-end"
      >
        <template #trigger>
          <div
            class="dropdown__trigger"
            @click="open = !open"
          >
            <div class="select__trigger">
              <span class="select__label select__label--flex select__label--flat">
                <template v-if="modelValue">
                  <template v-if="modelValue.isNew">
                    <span class="menu-item__label-icon">
                      <UseSvg
                        class="icon icon--small"
                        name="plus"
                      />
                    </span>
                    <span class="menu-item__label">
                      {{ $t('operations.new_division') }}
                    </span>
                  </template>
                  <span v-else>{{ modelValue.name }}</span>
                </template>
                <span
                  v-else
                  class="dim"
                >
                  {{ $t('operations.no_division') }}
                </span>
              </span>

              <span class="select__arrow">
                <UseSvg
                  class="icon icon--small"
                  name="arrow_down_16"
                />
              </span>
            </div>
          </div>
        </template>

        <div class="menu menu--dropdown">
          <ul class="menu__items">
            <li class="menu-item menu-item--dropdown">
              <button
                class="menu-item__link"
                type="button"
                @click="selectDivision(null)"
              >
                <span class="menu-item__label dim">
                  {{ $t('operations.no_division') }}
                </span>
              </button>
            </li>
            <li
              v-for="division in divisions"
              :key="division.id"
              class="menu-item menu-item--dropdown"
            >
              <button
                class="menu-item__link"
                type="button"
                @click="selectDivision(division)"
              >
                <span class="menu-item__label">
                  {{ division.name }}
                </span>
              </button>
            </li>
            <li class="menu-item menu-item--dropdown">
              <button
                class="menu-item__link"
                type="button"
                @click="selectDivision(newDivision())"
              >
                <UseSvg
                  class="icon icon--small menu-item__label-icon"
                  name="plus"
                />
                <span class="menu-item__label">
                  {{ $t('operations.new_division') }}
                </span>
              </button>
            </li>
          </ul>
        </div>
      </Popper>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { v4 as uuid } from 'uuid';

import Popper from '@/components/generic/popper.vue';
import UseSvg from '@/components/generic/use_svg.vue';

defineProps({
  modelValue: { type: Object, default: null },
  divisions: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:modelValue']);

const open = ref(false);

function newDivision() {
  return {
    id: uuid(),
    isNew: true,
  };
}

function selectDivision(division) {
  emit('update:modelValue', division);
  open.value = false;
}
</script>
